/* Carrossel de reviews com fotos: cabecalho tipo Trustpilot,
   estrelas em caixas verdes, cartao central com os vizinhos a
   espreitar, bolinhas e avanco automatico (padrao da Lea Versailles). */
(function () {
  var DELAY = 5000;
  var PAUSE_AFTER_TOUCH = 9000;
  var SCORE = '4.7';
  var COUNT_TEXT = '4.7/5 | Based on 3,500+ reviews';
  var WORD = 'Excellent';

  function starBox(half) {
    return '<span class="jo-star' + (half ? ' jo-star--half' : '') + '">&#9733;</span>';
  }

  function starRow(full, half) {
    var out = '<span class="jo-stars">';
    for (var i = 0; i < full; i++) out += starBox(false);
    if (half) out += starBox(true);
    out += '</span>';
    return out;
  }

  function cards(track) {
    return Array.prototype.slice.call(track.children).filter(function (el) {
      return el.className && (el.className + '').indexOf('ai-social-carousel__item') > -1;
    });
  }

  function centerOf(track, card) {
    return card.offsetLeft - (track.clientWidth - card.clientWidth) / 2;
  }

  function currentIndex(track, list) {
    var center = track.scrollLeft + track.clientWidth / 2;
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < list.length; i++) {
      var dist = Math.abs(list[i].offsetLeft + list[i].clientWidth / 2 - center);
      if (dist < bestDist) { bestDist = dist; best = i; }
    }
    return best;
  }

  function buildHead(track) {
    var host = track.parentNode;
    if (host.querySelector('.jo-rv-head')) return;
    var head = document.createElement('div');
    head.className = 'jo-rv-head';
    head.innerHTML =
      '<div class="jo-rv-head__top">' +
      '<span class="jo-rv-head__word">' + WORD + '</span>' +
      '<span class="jo-rv-head__score">' + SCORE + ' / 5</span>' +
      starRow(4, true) +
      '</div>' +
      '<p class="jo-rv-head__sub">' + COUNT_TEXT + '</p>';
    host.insertBefore(head, track);
  }

  function paintStars(list) {
    list.forEach(function (card) {
      var el = card.querySelector('[class*="ai-social-carousel__stars"]');
      if (!el || el.dataset.joStars === '1') return;
      el.dataset.joStars = '1';
      el.innerHTML = starRow(5, false);
    });
  }

  function setup(track) {
    if (track.dataset.joRv === '1') return;
    var list = cards(track);
    if (list.length < 2) return;
    track.dataset.joRv = '1';

    buildHead(track);
    paintStars(list);

    var dots = document.createElement('div');
    dots.className = 'jo-rv-dots';
    list.forEach(function (card, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'jo-rv-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Review ' + (i + 1));
      dot.addEventListener('click', function () {
        track.scrollTo({ left: centerOf(track, card), behavior: 'smooth' });
      });
      dots.appendChild(dot);
    });
    track.parentNode.insertBefore(dots, track.nextSibling);

    requestAnimationFrame(function () {
      track.scrollLeft = centerOf(track, list[0]);
    });

    var timer;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var index = currentIndex(track, list);
        Array.prototype.slice.call(dots.children).forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }, 60);
    }, { passive: true });

    var paused = false;
    var resumeTimer;
    function pause() {
      paused = true;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; }, PAUSE_AFTER_TOUCH);
    }
    ['mouseenter', 'touchstart', 'pointerdown', 'wheel'].forEach(function (evt) {
      track.addEventListener(evt, pause, { passive: true });
    });
    track.addEventListener('mouseleave', function () {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; }, 1200);
    });

    setInterval(function () {
      if (paused || document.hidden) return;
      var next = (currentIndex(track, list) + 1) % list.length;
      track.scrollTo({ left: centerOf(track, list[next]), behavior: 'smooth' });
    }, DELAY);
  }

  function init() {
    document.querySelectorAll('[class*="ai-social-carousel__wrapper"]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  setTimeout(init, 1500);
})();
